import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Meta, Title } from '@angular/platform-browser';
import { TenantConstant } from '@app-constants/tenant.constant';
import { openDefaultLoginDialog, openTermsAndConditionsDialog, signup, socialMediaClicked } from '@app-core/components/home/home.component';
import { BoardsService } from '@app-services/boarrds/boards.service';
import { SignupService } from '@app-services/signup/signup.service';
import { UserService } from '@app-services/user/user.service';
import { GAnalyticsService } from '@app-services/g-analytics/g-analytics.service';
import { openTSDialog } from 'src/app/helpers/methods';

@Component({
  selector: 'app-neet-landing',
  templateUrl: './neet-landing.component.html',
  styleUrls: ['./neet-landing.component.css']
})
export class NeetLandingComponent implements OnInit {
  @ViewChild('content') public content: any;
  signup = signup;
  openDefaultLoginDialog = openDefaultLoginDialog;
  openTermsAndConditionsDialog = openTermsAndConditionsDialog;
  socialMediaClicked = socialMediaClicked;
  openTSDialog = openTSDialog;
  mobileNumberForm: FormGroup;
  mobileNumberValid = false;
  tenant: any = TenantConstant.tenant;
  constructor(
    private titleService: Title,
    private metaService: Meta,    
    private dialog: MatDialog,
    public signUpService: SignupService,
    private gaService: GAnalyticsService,
    private fb:FormBuilder,
    private gradesService: BoardsService,
    public userService: UserService,) { }

  ngOnInit(): void {
    this.mobileNumberForm = this.fb.group({
      mobilenumber: ['', [Validators.required, Validators.pattern(/^(?:(?:\+|0{0,2})91(\s*[\ -]\s*)?|[0]?)?[6789]\d{9}|(\d[ -]?){10}\d$/)]]
    })
    this.titleService.setTitle('NEET Free Live Classes 2021 - Register Now | Infinity Learn');
    this.metaService.addTags([
      {name: 'keywords', content: 'NEET Online Classes, neet live classes, NEET Online Coaching, Best NEET Classes, neet online classes free, neet online classes app, neet ug, online crash course for neet, NEET free coaching, free coaching classes of NEET, Free NEET coaching app, online free NEET coaching, best free online tutor for NEET, Free online NEET mock test, NEET free online coaching, Free online NEET coaching, neet prep, neet coaching, neet online class, neet best coaching, best neet coaching online, best coaching institute for neet, best neet coaching institute, neet coaching center'},
      {name: 'description', content: 'Kickstart your NEET 2021 preparation with live online coaching for NEET with doubt clearing sessions by the top faculties.'},
    ])
  }
  openSignUpDialog(): void {
    this.openTSDialog({
      message: 'One more step and you are all set',
      source: 'Liveclasses',
      phone: this.mobileNumberForm.value.mobilenumber,
      countryCode: '+91',
    })
  }

  ngOnDestroy(){
  }
}

